import React, { FC, useEffect } from 'react';
import { useStore } from '../../../store/store-provider';
import { PresenterTabsOnMobile } from '../../../constans/presenter-enums';
import { observer } from 'mobx-react';

const PresenterSlidePermissionsHOC: FC = ({ children }): JSX.Element | null => {
  const { slideManagementStore, permissionsStore } = useStore();
  const { isPodiumSlidesEnabled } = permissionsStore;
  const {
    slideDeckUpdateSubscription,
    changeSlideCommandSubscription,
    setActiveMobileNavigationTab,
    isSlidesManagementAvailable
  } = slideManagementStore;

  useEffect(() => {
    if (!isPodiumSlidesEnabled()) return;
    const onDeckUpdateSubscription = slideDeckUpdateSubscription();
    const onCommandSlideChangeSubscription = changeSlideCommandSubscription();
    return () => {
      onDeckUpdateSubscription.unsubscribe();
      onCommandSlideChangeSubscription.unsubscribe();
    };
  }, [isPodiumSlidesEnabled()]);

  useEffect(() => {
    if(!isSlidesManagementAvailable) return;
    setActiveMobileNavigationTab(PresenterTabsOnMobile.CLICKER);
  }, [isSlidesManagementAvailable]);


  return <>{isSlidesManagementAvailable ? children : null}</>;
};

export default observer(PresenterSlidePermissionsHOC);
